import React from 'react';

const Terms : React.FC = () => {
  return(
    <div className="terms-container">
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> 2025-01-05</p>

      <h2>1. Description of Service</h2>
      <p>This Chrome extension helps users maximize their rewards by recommending which card to use on a given website.</p>

      <h2>2. Eligibility</h2>
      <p>There are no specific restrictions on who can use the extension, but it works best in the United States.</p>

      <h2>3. User Accounts</h2>
      <p>A user account is required to access the extension's features. However, you may log in anonymously without providing an email address if preferred.</p>

      <h2>4. Prohibited Uses</h2>
      <ul>
        <li>Reverse engineering or decompiling the extension.</li>
        <li>Using the extension for malicious or harmful purposes.</li>
      </ul>

      <h2>5. Accuracy of Recommendations</h2>
      <p>We strive to provide accurate recommendations, but the extension may produce incorrect results. We disclaim all liability for errors or inaccuracies in the recommendations provided.</p>

      <h2>6. Data Collection and Privacy</h2>
      <p>By installing the extension, you agree to the collection and use of your data as outlined in our <a href="/privacy">Privacy Policy</a>. You can delete your data at any time within the extension. Note that it may take up to two weeks for deletion to be fully completed.</p>

      <h2>7. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, we shall not be held liable for any damages, including direct, indirect, incidental, or consequential damages, arising from your use of the extension.</p>

      <h2>8. Disclaimer of Warranty</h2>
      <p>The extension is provided "as-is" and without warranties of any kind, whether express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.</p>

      <h2>9. Termination</h2>
      <p>We reserve the right to terminate your access to the extension at any time for any reason, including violations of these Terms of Service.</p>

      <h2>10. Modifications</h2>
      <p>We reserve the right to modify or discontinue the extension, or to update these Terms of Service, at any time without prior notice.</p>

      <h2>11. Governing Law</h2>
      <p>These Terms of Service shall be governed by and construed in accordance with the laws of the United States.</p>

      <h2>12. Dispute Resolution</h2>
      <p>Any disputes arising under these Terms of Service shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. By agreeing to these terms, you waive your right to a jury trial or to participate in a class action lawsuit.</p>

      <h2>13. Third-Party Services</h2>
      <p>We use observability tools to help with application debugging. By using the extension, you agree to the terms of these third-party services as they apply.</p>

      <h2>14. Commercial Use</h2>
      <p>The extension is for personal use only and may not be used for commercial purposes.</p>

      <h2>15. Contact Us</h2>
      <p>If you have any questions or concerns about these Terms of Service, please contact us at <a href="mailto:hello@stashr.ai">hello@stashr.ai</a>.</p>
    </div>
  )
}

export default Terms;
